import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=ce4d24e0&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=ce4d24e0&prod&lang=css&"
import style1 from "./edit.vue?vue&type=style&index=1&id=ce4d24e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4d24e0",
  null
  
)

export default component.exports